import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { Layout } from "@/components/Layout";
import { ProtectedRoute, AdminRoute } from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Catalogue from "@/pages/Catalogue";
import ProductDetails from "@/pages/ProductDetails";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Policies from "@/pages/Policies";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import OrderConfirmation from "@/pages/OrderConfirmation";
import MyAccount from "@/pages/MyAccount";

import { AdminLayout } from "@/admin/AdminLayout";
import AdminLogin from "@/admin/AdminLogin";
import Dashboard from "@/admin/Dashboard";
import AdminProducts from "@/admin/AdminProducts";
import ProductForm from "@/admin/ProductForm";
import AdminOrders from "@/admin/AdminOrders";
import AdminMessages from "@/admin/AdminMessages";
import AdminCustomers from "@/admin/AdminCustomers";
import AdminSettings from "@/admin/AdminSettings";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SettingsProvider>
            <CartProvider>
              <Toaster position="top-center" richColors />
              <Routes>
                {/* Public storefront */}
                <Route element={<Layout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/catalogue" element={<Catalogue />} />
                  <Route path="/product/:id" element={<ProductDetails />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/policies" element={<Policies />} />
                  <Route path="/cart" element={<ProtectedRoute><Cart /></ProtectedRoute>} />
                  <Route path="/checkout" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />
                  <Route path="/order-confirmation/:id" element={<ProtectedRoute><OrderConfirmation /></ProtectedRoute>} />
                  <Route path="/account" element={<ProtectedRoute><MyAccount /></ProtectedRoute>} />
                </Route>

                {/* Auth */}
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />

                {/* Admin */}
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route element={<AdminRoute><AdminLayout /></AdminRoute>}>
                  <Route path="/admin" element={<Dashboard />} />
                  <Route path="/admin/products" element={<AdminProducts />} />
                  <Route path="/admin/products/new" element={<ProductForm />} />
                  <Route path="/admin/products/:id/edit" element={<ProductForm />} />
                  <Route path="/admin/orders" element={<AdminOrders />} />
                  <Route path="/admin/messages" element={<AdminMessages />} />
                  <Route path="/admin/customers" element={<AdminCustomers />} />
                  <Route path="/admin/settings" element={<AdminSettings />} />
                </Route>
              </Routes>
            </CartProvider>
          </SettingsProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
